import { api } from './api';

// Native push registration via @capacitor-firebase/messaging.
//
// It returns an **FCM registration token** (not a raw APNs token), which is exactly what the
// backend FCM HTTP v1 sender (server/lib/push.ts) expects. Deliberately uses NO static import
// of @capacitor* — the plugin only exists inside the native app build, so on the web this is a
// clean no-op. Once the iOS shell ships (Firebase configured + GoogleService-Info.plist added),
// this picks up the device token and posts it to /api/push/register. Safe to call after login
// on every platform.
export async function initPushNotifications(): Promise<void> {
  const cap = (window as any).Capacitor;
  if (!cap?.isNativePlatform?.()) return; // web → nothing to register yet
  const FM = cap.Plugins?.FirebaseMessaging;
  if (!FM) return;

  const platform = cap.getPlatform?.() === 'android' ? 'android' : 'ios';
  const send = (token?: string) => {
    if (token) api.registerPush(token, platform).catch(() => { /* best-effort */ });
  };

  try {
    let perm = await FM.checkPermissions();
    if (perm?.receive === 'prompt' || perm?.receive === 'prompt-with-rationale') {
      perm = await FM.requestPermissions();
    }
    if (perm?.receive !== 'granted') return;

    // The FCM token can rotate — listen for refreshes, and also fetch the current one now.
    await FM.addListener('tokenReceived', (event: { token?: string }) => send(event?.token));
    const { token } = await FM.getToken();
    send(token);
  } catch (e) {
    console.error('initPushNotifications failed:', e);
  }
}
